<template>
  <div v-if="ligne" class="mgt-20px">
    <div class="columns">
      <v-client-table :data="ligne" class="column is-6"
                      :columns="columns"
                      :options="options">
        <div slot="patrimoine" slot-scope="props">
          {{ props.row.libelle }}
        </div>
        <div slot="typeProduit" slot-scope="props">
          <p v-for="(type, index) in getTypeProduit(props.row)" :key="index">{{ type }}</p>
        </div>
      </v-client-table>
      <div class="column is-6 mgt-10px">
        <b-field :label="$t('listeEcheances.table.childrow.commentaireFacturation')">
          {{ data.commentaireFacturation }}
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailEcheancierLigne } from '@/api/echeancier/index';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PAGINATION, NO_PER_PAGE_VALUE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'detailProduitEcheance',
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      ligne: null,
    };
  },
  computed: {
    columns() {
      return ['patrimoine', 'typeProduit'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          patrimoine: this.$i18n.t('commandeBaf.tab.childrow.patrimoine'),
          typeProduit: this.$i18n.t('commandeBaf.tab.childrow.typeProduit'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        columnsClasses: {
          patrimoine: 'width-50-percent',
        },
        sortable: [],
        sortIcon: SORT_ICON,
      };
    },
  },
  methods: {
    getTypeProduit(ligneInformations) {
      const typeProduit = [];
      ligneInformations.lignesCommande.forEach((ligne) => {
        typeProduit.push(ligne.libelle);
      });
      return typeProduit;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.ligne = (await getDetailEcheancierLigne(this.data.id)).data.result;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
